export default __webpack_public_path__ + "static/media/simcase_wide.9a676a28.png";